import React from 'react';

var WebGameColHeaderWr = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'top-inner-wrapper' }, children);
};

export { WebGameColHeaderWr };
